// Invoice pattern update
export const UPDATE_INVOICE_PATTERN_LOADING = 'UPDATE_INVOICE_PATTERN_LOADING';
export const UPDATE_INVOICE_PATTERN_SUCCESS = 'UPDATE_INVOICE_PATTERN_SUCCESS';
export const UPDATE_INVOICE_PATTERN_FAILURE = 'UPDATE_INVOICE_PATTERN_FAILURE';

export const DELETE_CUSTOM_EXPORT_SUCCESS = 'DELETE_CUSTOM_EXPORT_SUCCESS';

// Bases
export const FETCH_BASES_LOADING = 'FETCH_BASES_LOADING';
export const FETCH_BASES_SUCCESS = 'FETCH_BASES_SUCCESS';
export const FETCH_BASES_FAILURE = 'FETCH_BASES_FAILURE';

// Toggle active export
export const TOGGLE_ACTIVE_EXPORT_SUCCESS = 'TOGGLE_ACTIVE_EXPORT_SUCCESS';
